// eslint-disable-next-line kf/const-naming-convention
export const FieldTypes = {
  string: primitiveTypeChecker("string"),
  number: primitiveTypeChecker("number"),
  boolean: primitiveTypeChecker("boolean"),
  array: primitiveTypeChecker("array"),
  function: primitiveTypeChecker("function"),
  object: objectTypeChecker, //used only in report appearance and Scheduler Integration
  any: anyTypeChecker,
  kindOf: modelTypeChecker,
  oneOfType: oneOfTypeChecker
};

function primitiveTypeChecker(expectedType) {
  function validate(isRequired, name, value) {
    var fieldType = Array.isArray(value) ? "array" : typeof value;
    if (isRequired && fieldType === "string" && value == null) {
      throw new Error(
        `The field '${name}' is marked as required, but its value is null`
      );
    } else if (isRequired && fieldType === "array" && value.length === 0) {
      throw new Error(
        `The field '${name}' is marked as required, but its value is empty`
      );
    } else if (value != null && fieldType !== expectedType) {
      throw new Error(
        `Invalid type for the field '${name}' '${fieldType}', expected '${expectedType}'`
      );
    }
  }
  //to access which type is expected in oneOf validation
  validate.type = expectedType;

  return chainableTypeChecker(validate);
}

function oneOfTypeChecker(expectedTypes = [FieldTypes.string]) {
  function validate(isRequired, name, value) {
    var fieldDataType = Array.isArray(value) ? "array" : typeof value;
    expectedTypes.every((dataTypes) => {
      if (fieldDataType === dataTypes.type) {
        dataTypes(name, value);
        return false;
      }
      return true;
    });
  }
  //to access which type is expected in oneOf validation
  validate.type = expectedTypes;

  return chainableTypeChecker(validate);
}

function modelTypeChecker(expectedModelName) {
  function validate(isRequired, name, value) {
    if (isRequired && value == null) {
      throw new Error(
        `The field '${name}' is marked as required, but its value is null`
      );
    } else if (value) {
      // Ignore model name check for "Report" since Id of "AllItemReport" generated from backend.
      if (
        value.toString().indexOf(expectedModelName) !== 0 &&
        [
          "Report",
          "Field",
          "Model",
          "Integration",
          "Application",
          "Page",
          "Navigation",
          "Menu",
          "Connector"
        ].indexOf(expectedModelName) < 0
      ) {
        throw new Error(`Invalid type for the field '${name}' '${value}',
          expected reference to '${expectedModelName}'`);
      }
    }
  }
  //to access which type is expected in oneOf validation
  validate.type = expectedModelName;

  return chainableTypeChecker(validate, expectedModelName);
}

function objectTypeChecker(objectSchema) {
  function validate(isRequired, name, valueObj) {
    if (isRequired && valueObj == null) {
      throw new Error(
        `The field '${name}' is marked as required, but its value is null`
      );
    } else if (valueObj) {
      for (let property in valueObj) {
        let validator = objectSchema[property];
        if (!validator) {
          throw new Error(
            `All the values in this field must be unique. Please enter a different value.`
          );
        }
        validator(property, valueObj[property]);
      }
    }
  }

  return chainableTypeChecker(validate);
}

function anyTypeChecker() {
  return true;
}

function chainableTypeChecker(validate, referenceName = null) {
  let chainedTypeChecker = validate.bind(null, false);
  chainedTypeChecker.type = validate.type;
  chainedTypeChecker.isRequired = validate.bind(null, true);
  // used to check if the field is required or not
  chainedTypeChecker.isRequired.required = true;
  let isReference = () => {
    if (referenceName) {
      return true;
    }
    return false;
  };
  chainedTypeChecker.isReference = isReference;
  chainedTypeChecker.isRequired.isReference = isReference;
  return chainedTypeChecker;
}
